import React from 'react';
import styled from 'styled-components';
import { ReactComponent as Arrow } from '../img/arrow-right.svg';
import { ReactComponent as Pin } from '../img/pin.svg';

const SingleLocation = ({ location, click }: any) => {
  // console.log('day', new Date().getDay());
  return (
    <SingleResult onClick={click}>
      <Contents>
        <h5>
          <a href={location.url}>{location.name}</a>
        </h5>
        <p>
          {location.streetAddress} <br />
          {location.locality} {location.region}, {location.zip}
        </p>
        <p style={{ marginBottom: 10 }}>{location.phone}</p>
        {location.hours &&
          location.hours.map((hour: any) => (
            <p className="sm" key={hour.label}>
              {hour.label}: {hour.location_hours}
            </p>
          ))}
      </Contents>
      <Links>
        {location.distance && (
          <Miles>
            <Pin />
            {location.distance.toFixed(2)} miles
          </Miles>
        )}
        <Button href={location.url}>
          More Information <Arrow />
        </Button>
        {location.orderUrl && (
          <Button href={location.orderUrl}>
            Order Now <Arrow />
          </Button>
        )}
      </Links>
    </SingleResult>
  );
};

export default SingleLocation;

const SingleResult = styled.div`
  border: 1px solid #ccc;
  margin-bottom: 40px;
  cursor: pointer;
  width: 100%;
  box-sizing: border-box;
  display: inline-block;
  overflow: hidden;

  &:hover {
    background: #eee !important;
  }
`;

const Contents = styled.div`
  padding: 20px 30px;
  width: 100%;
  h5 {
    margin: 0;
    text-transform: uppercase;
  }

  a {
    color: #000;
    font-weight: bold;
    text-decoration: none;
    font-size: 16px;
    margin: 0;
    font-weight: bold;
    line-height: 1.5;

    &:hover {
      text-decoration: underline;
    }
  }

  p {
    font-size: 13px;
    margin-top: 5px;
    margin-bottom: 0px;
    line-height: 1.3;
    font-weight: 400;
    color: #292b2c;

    &.sm {
      font-size: 12px;
      margin: 0 0;
    }
  }
  @media all and (max-width: 600px) {
    padding: 20px 15px;
    a {
      line-height: 1;
    }
  }
`;

const Links = styled.div`
  border-top: 1px solid #ccc;
  padding: 0px 30px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-content: center;
  align-items: center;

  @media all and (max-width: 600px) {
    padding: 0 10px;
    flex-wrap: wrap;
    justify-content: space-evenly;
  }
`;

const Button = styled.a`
  display: inline-block;
  border: none;
  box-shadow: none;
  cursor: pointer;
  font-size: 0.875rem;
  border-radius: 0.2rem;
  font-weight: 400;
  color: #000;
  text-transform: uppercase;
  font-weight: bold;
  margin: 10px 0;
  text-decoration: none;
  transition: all 0.2s ease-in-out;
  vertical-align: middle;
  line-height: 1;

  svg {
    width: 10px;
    line-height: 1;
    display: inline-block;
    vertical-align: middle;
    margin-top: -4px;
  }

  &:hover {
    color: #8bbf3f;
    border-bottom: none;
  }
`;

const Miles = styled.p`
  display: inline-block;
  border: none;
  box-shadow: none;
  cursor: pointer;
  font-size: 12px;
  border-radius: 0.2rem;
  font-weight: 400;
  color: #000;
  font-weight: bold;
  margin: 0;
  text-decoration: none;
  transition: all 0.2s ease-in-out;
  vertical-align: middle;
  line-height: 1;

  svg {
    width: 14px;
    line-height: 1;
    display: inline-block;
    vertical-align: middle;
    margin-top: -4px;
    fill: #8bbf3f;
    margin-right: 5px;

    path {
      fill: #8bbf3f;
    }
  }
`;
